import { useCallback, useMemo } from 'react';
import { paymentControlState, useAppSelector } from 'src/store';
import { PlanFamily } from 'src/types';

export const usePaymentControlState = () => {
  const {
    selectedPeriod,
    selectedFamily,
    selectedPlanSetByFamily,
    selectedPaymentTab,
    selectedPlan,
  } = useAppSelector(paymentControlState);

  const selectedPlanKind = useMemo(
    () => selectedFamily && selectedPlanSetByFamily[selectedFamily],
    [selectedPlanSetByFamily, selectedFamily],
  );

  const getDisplayedPlanKindByFamily = useCallback(
    (planFamily: PlanFamily) => {
      return selectedPlanSetByFamily[planFamily];
    },
    [selectedPlanSetByFamily],
  );

  return {
    selectedPeriod,
    selectedFamily,
    selectedPlanKind,
    selectedPlanSetByFamily,
    getDisplayedPlanKindByFamily,
    selectedPaymentTab,
    selectedPlan,
  };
};
